import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import axios from 'axios';
import { startsWith, toUpper } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { actions } from '../../../actions';
import collections from '../../../constants/FirestoreCollections';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    container: {
      height: '300px',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '1em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
    item: {
      display: 'flex',
    },
    reference: {
      color: '#aaa',
    },
  }));
};

export default function Permissions(props) {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles(small)();

  // states
  const [searchEmail, setSearchEmail] = useState('');
  const [openDropdown, setOpenDropdown] = useState(-1);
  const [users, setUsers] = useState([]);
  const [unsubscribers, setUnsubscribers] = useState([]);

  // hooks
  const firebase = useFirebase();
  const appDispatch = useDispatch();
  const firestore = useFirestore();
  const projectId = process.env.REACT_APP_PROJECT_ID;

  // methods
  const handleChangePermissions = async (user) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function (token) {
        axios(`https://us-central1-${projectId}.cloudfunctions.net/auth/claims`, {
          method: 'post',
          headers: {
            Authorization: `bearer ${token}`,
          },
          data: {
            uid: user.id,
            isAdmin: !(user.claims && user.claims.includes('admin')),
          },
        })
          .then(() => {
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: '!Usuario actualizado exitosamente!',
                snackbarSeverity: 'success',
              },
            });
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err && err.response);
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      })
      .catch(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };
  const handleOpenDropdown = (current) => {
    if (openDropdown === current) setOpenDropdown(-1);
    else setOpenDropdown(current);
  };

  // effects
  useEffect(() => {
    if (openDropdown === 1 && (!users || users.length === 0)) {
      const unsubscribe = firestore.collection(collections.users).onSnapshot((snapshot) => {
        const tmpUsers = [];
        snapshot.forEach((e) => tmpUsers.push({ id: e.id, ...e.data() }));
        setUsers(
          tmpUsers.filter(
            (user) => user && (!user.claims || !user.claims.includes('organizationsViewer')),
          ),
        );
      });
      if (unsubscribers && unsubscribers[0]) unsubscribers[0]();
      setUnsubscribers([unsubscribe]);
    }
  }, [firestore, openDropdown]);

  return (
    <Box>
      <Typography>
        <b>PERMISOS DE ADMINISTRADOR</b>
        <IconButton onClick={() => handleOpenDropdown(1)} size="large">
          {openDropdown === 1 ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
      </Typography>
      {openDropdown === 1 && (
        <Box className={classes.container} pb={4}>
          <Grid item xs={12} sm={11}>
            <FormControl fullWidth>
              <TextField
                id="standard-basic"
                label="Buscar"
                onChange={(event) => setSearchEmail(event.target.value)}
              />
            </FormControl>
          </Grid>
          {(!users || users.length === 0) && <Typography>No hay usuarios aún</Typography>}
          {users &&
            users
              .filter((e) => startsWith(toUpper(e.email), toUpper(searchEmail)))
              .map((user, index) => (
                <Box key={index} py={2}>
                  <Grid className={classes.item} item xs={12} sm={11}>
                    <Box display="flex" alignItems="center" width="100%">
                      <Box mr={1} className={classes.reference}>
                        Email:{' '}
                      </Box>
                      <Typography>{user.email}</Typography>
                      <Box ml="auto">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleChangePermissions(user)}
                        >
                          {user.claims && user.claims.includes('admin')
                            ? 'Quitar permisos'
                            : 'Añadir permisos'}
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                </Box>
              ))}
        </Box>
      )}
    </Box>
  );
}
